import i18n from '../language/index'
// 所有列表数据的配置
// value和label属性类型是string
export default {
  // 系统定义
  systemDefine: [{
      value: 'default',
      label: i18n.t('view_back_top_edit_103'),
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'hidden',
      label: i18n.t('view_back_top_index_105'),
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'self',
      label: i18n.t('view_back_top_edit_102'),
      disabled: 'false',
      show: 'true'
    }
  ],
  defaultCustom: [{
      value: 'default',
      label: i18n.t('view_back_top_edit_103'),
    },
    {
      value: 'custom',
      label: i18n.t('view_back_top_edit_102'),
    }
  ],
  backgroundType: [{
      value: 'color',
      label: 'base_options_config_1673'
    },
    {
      value: 'default',
      label: 'view_download_index_180'
    }
  ],
  color_Pattern: [{
      value: 'pure_color',
      label: i18n.t('base_options_config_1674')
    },
    {
      value: 'linear_gradient',
      label: i18n.t('base_options_config_1675')
    }
  ],
  borderPosition: [{
      value: 'borderTopWidth',
      label: i18n.t('base_options_config_1676'),
      disabled: 'false'
    },
    {
      value: 'borderBottomWidth',
      label: i18n.t('base_options_config_1677'),
      disabled: 'false'
    },
    {
      value: 'borderLeftWidth',
      label: i18n.t('base_options_config_1678'),
      disabled: 'false'
    },
    {
      value: 'borderRightWidth',
      label: i18n.t('base_options_config_1679'),
      disabled: 'false'
    }
  ],
  checkValueList: ['borderTopWidth', 'borderBottomWidth', 'borderLeftWidth', 'borderRightWidth'],
  lineType: [{
      value: 'solid',
      title: i18n.t('base_options_config_1680'),
      label: '————'
    },
    {
      value: 'dotted',
      title: i18n.t('base_options_config_1681'),
      label: '·················'
    },
    {
      value: 'dashed',
      title: i18n.t('base_options_config_1682'),
      label: '----------'
    }
  ],
  textAlign: [{
      value: 'left',
      label: i18n.t('base_kindeditor_all_1503'),
      icon: ''
    },
    {
      value: 'center',
      label: i18n.t('base_options_config_1683'),
      icon: ''
    },
    {
      value: 'right',
      label: i18n.t('base_kindeditor_all_1504'),
      icon: ''
    },
    {
      value: 'justify',
      label: i18n.t('base_kindeditor_all_1505'),
      icon: ''
    }
  ],
  iconAlign: [{
    value: 'default',
    label: 'view_back_top_edit_103'
  }, {
    value: 'left',
    label: 'base_options_config_1684'
  }, {
    value: 'center',
    label: 'widgets_basic_floating_frame_edit_537'
  }, {
    value: 'right',
    label: 'base_options_config_1685'
  }, ],
  iconAlignStyle1: [{
    value: 'default',
    label: 'view_back_top_edit_103'
  }, {
    value: 'top',
    label: 'base_options_config_1686'
  }, {
    value: 'center',
    label: 'widgets_basic_floating_frame_edit_537'
  }, {
    value: 'bottom',
    label: 'base_options_config_1687'
  }, ],
  buttonTextAlign: [{
      value: 'left',
      label: i18n.t('base_options_config_1684'),
      icon: ''
    },
    {
      value: 'center',
      label: i18n.t('widgets_basic_floating_frame_edit_537'),
      icon: ''
    }
  ],
  lineHeight: [{
      label: i18n.t('view_back_top_edit_103'),
      value: 10
    },
    {
      label: '12px',
      value: 12
    },
    {
      label: '13px',
      value: 13
    },
    {
      label: '14px',
      value: 14
    },
    {
      label: '15px',
      value: 15
    },
    {
      label: '16px',
      value: 16
    },
    {
      label: '17px',
      value: 17
    },
    {
      label: '18px',
      value: 18
    },
    {
      label: '19px',
      value: 19
    },
    {
      label: '20px',
      value: 20
    },
    {
      label: '21px',
      value: 21
    },
    {
      label: '22px',
      value: 22
    },
    {
      label: '23px',
      value: 23
    },
    {
      label: '24px',
      value: 24
    },
    {
      label: '25px',
      value: 25
    },
    {
      label: '26px',
      value: 26
    },
    {
      label: '27px',
      value: 27
    },
    {
      label: '28px',
      value: 28
    },
    {
      label: '29px',
      value: 29
    },
    {
      label: '30px',
      value: 30
    },
    {
      label: '31px',
      value: 31
    },
    {
      label: '32px',
      value: 32
    },
    {
      label: '33px',
      value: 33
    },
    {
      label: '34px',
      value: 34
    },
    {
      label: '35px',
      value: 35
    },
    {
      label: '36px',
      value: 36
    },
    {
      label: '37px',
      value: 37
    },
    {
      label: '38px',
      value: 38
    },
    {
      label: '39px',
      value: 39
    },
    {
      label: '40px',
      value: 40
    },
    {
      label: '41px',
      value: 41
    },
    {
      label: '42px',
      value: 42
    },
    {
      label: '43px',
      value: 43
    },
    {
      label: '44px',
      value: 44
    },
    {
      label: '45px',
      value: 45
    },
    {
      label: '46px',
      value: 46
    },
    {
      label: '47px',
      value: 47
    },
    {
      label: '48px',
      value: 48
    },
    {
      label: '49px',
      value: 49
    },
    {
      label: '50px',
      value: 50
    },
    {
      label: '51px',
      value: 51
    },
    {
      label: '52px',
      value: 52
    },
    {
      label: '53px',
      value: 53
    },
    {
      label: '54px',
      value: 54
    },
    {
      label: '55px',
      value: 55
    },
    {
      label: '56px',
      value: 56
    },
    {
      label: '57px',
      value: 57
    },
    {
      label: '58px',
      value: 58
    },
    {
      label: '59px',
      value: 59
    },
    {
      label: '60px',
      value: 60
    },
    {
      label: '61px',
      value: 61
    },
    {
      label: '62px',
      value: 62
    },
    {
      label: '63px',
      value: 63
    },
    {
      label: '64px',
      value: 64
    },
    {
      label: '65px',
      value: 65
    },
    {
      label: '66px',
      value: 66
    },
    {
      label: '67px',
      value: 67
    },
    {
      label: '68px',
      value: 68
    },
    {
      label: '69px',
      value: 69
    },
    {
      label: '70px',
      value: 70
    },
    {
      label: '71px',
      value: 71
    },
    {
      label: '72px',
      value: 72
    },
    {
      label: '73px',
      value: 73
    },
    {
      label: '74px',
      value: 74
    },
    {
      label: '75px',
      value: 75
    },
    {
      label: '76px',
      value: 76
    },
    {
      label: '77px',
      value: 77
    },
    {
      label: '78px',
      value: 78
    },
    {
      label: '79px',
      value: 79
    },
    {
      label: '80px',
      value: 80
    },
    {
      label: '81px',
      value: 81
    },
    {
      label: '82px',
      value: 82
    },
    {
      label: '83px',
      value: 83
    },
    {
      label: '84px',
      value: 84
    },
    {
      label: '85px',
      value: 85
    },
    {
      label: '86px',
      value: 86
    },
    {
      label: '87px',
      value: 87
    },
    {
      label: '88px',
      value: 88
    },
    {
      label: '89px',
      value: 89
    },
    {
      label: '90px',
      value: 90
    },
    {
      label: '91px',
      value: 91
    },
    {
      label: '92px',
      value: 92
    },
    {
      label: '93px',
      value: 93
    },
    {
      label: '94px',
      value: 94
    },
    {
      label: '95px',
      value: 95
    },
    {
      label: '96px',
      value: 96
    },
    {
      label: '97px',
      value: 97
    },
    {
      label: '98px',
      value: 98
    },
    {
      label: '99px',
      value: 99
    }
  ],
  newFontSize: [{
      label: '12px',
      value: 12
    },
    {
      label: '14px',
      value: 14
    },
    {
      label: '16px',
      value: 16
    },
    {
      label: '18px',
      value: 18
    },
    {
      label: '20px',
      value: 20
    },
    {
      label: '24px',
      value: 24
    },
    {
      label: '30px',
      value: 30
    }
  ],
  fontSize: [{
      label: '12px',
      value: 12
    },
    {
      label: '14px',
      value: 14
    },
    {
      label: '16px',
      value: 16
    },
    {
      label: '18px',
      value: 18
    },
    {
      label: '20px',
      value: 20
    },
    {
      label: '24px',
      value: 24
    },
    {
      label: '30px',
      value: 30
    },
    {
      label: '36px',
      value: 36
    },
    {
      label: '48px',
      value: 48
    },
    {
      label: '60px',
      value: 60
    },
    {
      label: '72px',
      value: 72
    },
    {
      label: '84px',
      value: 84
    },
    {
      label: '96px',
      value: 96
    },
    {
      label: '108px',
      value: 108
    },
    {
      label: '120px',
      value: 120
    }
  ],
  navFontSizeOption: [{
      label: '12px',
      value: 12
    },
    {
      label: '13px',
      value: 13
    },
    {
      label: '14px',
      value: 14
    },
    {
      label: '15px',
      value: 15
    },
    {
      label: '16px',
      value: 16
    },
    {
      label: '17px',
      value: 17
    },
    {
      label: '18px',
      value: 18
    },
    {
      label: '19px',
      value: 19
    },
    {
      label: '20px',
      value: 20
    },
    {
      label: '21px',
      value: 21
    },
    {
      label: '22px',
      value: 22
    },
    {
      label: '23px',
      value: 23
    },
    {
      label: '24px',
      value: 24
    },
    {
      label: '25px',
      value: 25
    },
    {
      label: '26px',
      value: 26
    },
    {
      label: '27px',
      value: 27
    },
    {
      label: '28px',
      value: 28
    },
    {
      label: '29px',
      value: 29
    },
    {
      label: '30px',
      value: 30
    }
  ],
  fontFamilyZh: [{
      "value": "Arial",
      "label": "Arial",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "Tahoma",
      "label": "Tahoma",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "impact",
      "label": "Impact",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "Arial Serif",
      "label": "Arial Serif",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "Times New Roman",
      "label": "Times New Roman",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "Georgia",
      "label": "Georgia",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "Garamond",
      "label": "Garamond",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "andale mono",
      "label": "Andale mono",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "arial black, avant garde",
      "label": "Arial Black",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "comic sans ms",
      "label": "Comic sans ms",
      "isSystem": true,
      "lang": 'en'
    },
    {
      "value": "宋体, SimSun",
      "label": "宋体",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "新细明体, PMingLiU",
      "label": "新细明体",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "仿宋,FangSong_GB2312",
      "label": "仿宋_GB2312",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "微软雅黑, Microsoft YaHei",
      "label": "微软雅黑",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "隶书, SimLi",
      "label": "隶书",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "幼圆",
      "label": "幼圆",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "华文楷体 ,STKaiti",
      "label": "华文楷体",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "方正舒体",
      "label": "方正舒体",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "华文行楷",
      "label": "华文行楷",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "华文彩云",
      "label": "华文彩云",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "华文宋体",
      "label": "华文宋体",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "楷体,楷体_GB2312,SimKai",
      "label": "楷体",
      "isSystem": true,
      "lang": 'zh'
    },
    {
      "value": "黑体, SimHei",
      "label": "黑体",
      "isSystem": true,
      "lang": 'zh'
    },
  ],
  fontFamilyEn: [{
      "value": "Tahoma, 微软雅黑",
      "label": "Tahoma",
      "isSystem": true
    },
    {
      "value": "impact, 微软雅黑",
      "label": "impact",
      "isSystem": true
    },
    {
      "value": "Arial Serif, 微软雅黑",
      "label": "Arial Serif",
      "isSystem": true
    },
    {
      "value": "Times New Roman, 微软雅黑",
      "label": "Times New Roman",
      "isSystem": true
    },
    {
      "value": "Arial,微软雅黑",
      "label": "Arial",
      "isSystem": true
    },
    {
      "value": "Georgia, 微软雅黑",
      "label": "Georgia",
      "isSystem": true
    },
    {
      "value": "Garamond, 微软雅黑",
      "label": "Garamond",
      "isSystem": true
    },
    {
      "value": "andale mono, 微软雅黑",
      "label": "andale mono",
      "isSystem": true
    },
    {
      "value": "arial black, avant garde, 微软雅黑",
      "label": "arial black",
      "isSystem": true
    },
    {
      "value": "comic sans ms, 微软雅黑",
      "label": "comic sans ms",
      "isSystem": true
    }
  ],
  fontFamilyFree: [{
      "value": "13",
      "label": "站酷小薇LOGO体",
      lang: 'zh'
    },
    {
      "value": "14",
      "label": "站酷庆科黄油体",
      lang: 'zh'
    },
    {
      "value": "15",
      "label": "站酷快乐体2016修订版",
      lang: 'zh'
    },
    {
      "value": "16",
      "label": "站酷快乐体_1",
      lang: 'zh'
    },
    {
      "value": "17",
      "label": "站酷文艺体",
      lang: 'zh'
    },
    {
      "value": "18",
      "label": "站酷酷黑_0",
      lang: 'zh'
    },
    {
      "value": "19",
      "label": "站酷高端黑修订版1.13_0",
      lang: 'zh'
    },
    // {
    //   "value": "20",
    //   "label": "Facile Sans",
    //   lang: 'en'
    // },
    {
      "value": "21",
      "label": "Facile-Sans",
      lang: 'en'
    },
    {
      "value": "22",
      "label": "FandolBraille-Display",
      lang: 'en'
    },
    {
      "value": "23",
      "label": "FandolBraille-Regular",
      lang: 'en'
    },
    {
      "value": "24",
      "label": "FandolFang-Regular",
      lang: 'en'
    },
    {
      "value": "25",
      "label": "FandolHei-Bold",
      lang: 'en'
    },
    {
      "value": "26",
      "label": "FandolKai-Regular",
      lang: 'en'
    },
    {
      "value": "27",
      "label": "FandolSong-Bold",
      lang: 'en'
    },
    {
      "value": "28",
      "label": "FengardoNeue_Black",
      lang: 'en'
    },
    {
      "value": "29",
      "label": "FengardoNeue_Regular_0",
      lang: 'en'
    },
    {
      "value": "30",
      "label": "GenShinGothic-Bold",
      lang: 'en'
    },
    {
      "value": "31",
      "label": "GenShinGothic-ExtraLight",
      lang: 'en'
    },
    {
      "value": "32",
      "label": "GenShinGothic-Heavy",
      lang: 'en'
    },
    {
      "value": "33",
      "label": "GenShinGothic-Light",
      lang: 'en'
    },
    {
      "value": "34",
      "label": "GenShinGothic-Medium",
      lang: 'en'
    },
    {
      "value": "35",
      "label": "GenShinGothic-Monospace-Bold",
      lang: 'en'
    },
    {
      "value": "36",
      "label": "GenShinGothic-Monospace-ExtraLight",
      lang: 'en'
    },
    {
      "value": "37",
      "label": "GenShinGothic-Monospace-Heavy",
      lang: 'en'
    },
    {
      "value": "38",
      "label": "GenShinGothic-Monospace-Light",
      lang: 'en'
    },
    {
      "value": "39",
      "label": "GenShinGothic-Monospace-Medium",
      lang: 'en'
    },
    {
      "value": "40",
      "label": "GenShinGothic-Monospace-Normal",
      lang: 'en'
    },
    {
      "value": "41",
      "label": "GenShinGothic-Monospace-Regular",
      lang: 'en'
    },
    {
      "value": "42",
      "label": "GenShinGothic-Normal",
      lang: 'en'
    },
    {
      "value": "43",
      "label": "GenShinGothic-P-Bold",
      lang: 'en'
    },
    {
      "value": "44",
      "label": "GenShinGothic-P-ExtraLight",
      lang: 'en'
    },
    {
      "value": "45",
      "label": "GenShinGothic-P-Heavy",
      lang: 'en'
    },
    {
      "value": "46",
      "label": "GenShinGothic-P-Light",
      lang: 'en'
    },
    {
      "value": "47",
      "label": "GenShinGothic-P-Medium",
      lang: 'en'
    },
    {
      "value": "48",
      "label": "GenShinGothic-P-Normal",
      lang: 'en'
    },
    {
      "value": "49",
      "label": "GenShinGothic-P-Regular",
      lang: 'en'
    },
    {
      "value": "50",
      "label": "GenShinGothic-Regular",
      lang: 'en'
    },
    {
      "value": "51",
      "label": "NotoSansHans-Black_1",
      lang: 'en'
    },
    {
      "value": "52",
      "label": "NotoSansHans-Bold_1",
      lang: 'en'
    },
    {
      "value": "53",
      "label": "NotoSansHans-DemiLight_0",
      lang: 'en'
    },
    {
      "value": "54",
      "label": "NotoSansHans-Light_1",
      lang: 'en'
    },
    {
      "value": "55",
      "label": "NotoSansHans-Medium_0",
      lang: 'en'
    },
    {
      "value": "56",
      "label": "NotoSansHans-Regular_0",
      lang: 'en'
    },
    {
      "value": "57",
      "label": "NotoSansHans-Thin-Windows_0",
      lang: 'en'
    },
    {
      "value": "58",
      "label": "SIMHEI",
      lang: 'en'
    },
    {
      "value": "59",
      "label": "SIMKAI",
      lang: 'en'
    },
    {
      "value": "60",
      "label": "arial",
      lang: 'en'
    },
    {
      "value": "61",
      "label": "arialbd",
      lang: 'en'
    },
    {
      "value": "62",
      "label": "arialbi",
      lang: 'en'
    },
    {
      "value": "63",
      "label": "ariali",
      lang: 'en'
    },
    {
      "value": "64",
      "label": "msyh",
      lang: 'en'
    },
    {
      "value": "65",
      "label": "msyhbd",
      lang: 'en'
    },
    {
      "value": "66",
      "label": "segoeui",
      lang: 'en'
    },
    {
      "value": "67",
      "label": "segoeuib",
      lang: 'en'
    },
    {
      "value": "68",
      "label": "segoeuii",
      lang: 'en'
    },
    {
      "value": "69",
      "label": "segoeuil",
      lang: 'en'
    },
    {
      "value": "70",
      "label": "segoeuiz",
      lang: 'en'
    },
    { "value": "74", "label": "Alegreya-Italic", "lang": "en" }, { "value": "75", "label": "Alegreya-Regular", "lang": "en" }, { "value": "76", "label": "Archivo-Regular", "lang": "en" }, { "value": "77", "label": "Archivo-Thin", "lang": "en" }, { "value": "78", "label": "Baloo2-Regular", "lang": "en" }, { "value": "79", "label": "BlackOpsOne-Regular", "lang": "en" }, { "value": "80", "label": "Caveat-Regular", "lang": "en" }, { "value": "81", "label": "Cinzel-Regular", "lang": "en" }, { "value": "82", "label": "CoveredByYourGrace-Regular", "lang": "en" }, { "value": "83", "label": "DMSerifDisplay-Italic", "lang": "en" }, { "value": "84", "label": "DMSerifDisplay-Regular", "lang": "en" }, { "value": "85", "label": "EBGaramond-Italic", "lang": "en" }, { "value": "86", "label": "EBGaramond-Regular", "lang": "en" }, { "value": "87", "label": "FredokaOne-Regular", "lang": "en" }, { "value": "88", "label": "Italiana-Regular", "lang": "en" }, { "value": "89", "label": "KronaOne-Regular", "lang": "en" }, { "value": "90", "label": "LibreBaskerville-Italic", "lang": "en" }, { "value": "91", "label": "LibreBaskerville-Regular", "lang": "en" }, { "value": "92", "label": "Lora-Italic", "lang": "en" }, { "value": "93", "label": "Lora-Regular", "lang": "en" }, { "value": "94", "label": "Merriweather-Black", "lang": "en" }, { "value": "95", "label": "Merriweather-Light", "lang": "en" }, { "value": "96", "label": "Merriweather-Regular", "lang": "en" }, { "value": "97", "label": "MetalMania-Regular", "lang": "en" }, { "value": "98", "label": "Montserrat-Regular", "lang": "en" }, { "value": "99", "label": "Montserrat-Thin", "lang": "en" }, { "value": "100", "label": "Nunito-ExtraLight", "lang": "en" }, { "value": "101", "label": "Nunito-Regular", "lang": "en" }, { "value": "102", "label": "Oregano-Italic", "lang": "en" }, { "value": "103", "label": "Oregano-Regular", "lang": "en" }, { "value": "104", "label": "Oswald-ExtraLight", "lang": "en" }, { "value": "105", "label": "Oswald-Regular", "lang": "en" }, { "value": "106", "label": "Pacifico-Regular", "lang": "en" }, { "value": "107", "label": "Philosopher-Italic", "lang": "en" }, { "value": "108", "label": "Philosopher-Regular", "lang": "en" }, { "value": "109", "label": "PlayfairDisplay-Italic", "lang": "en" }, { "value": "110", "label": "PlayfairDisplay-Regular", "lang": "en" }, { "value": "111", "label": "PTSerif-Italic", "lang": "en" }, { "value": "112", "label": "PTSerif-Regular", "lang": "en" }, { "value": "113", "label": "Quantico-Regular", "lang": "en" }, { "value": "114", "label": "Rajdhani-Light", "lang": "en" }, { "value": "115", "label": "Rajdhani-Regular", "lang": "en" }, { "value": "116", "label": "RaviPrakash-Regular", "lang": "en" }, { "value": "117", "label": "Roboto-Regular", "lang": "en" }, { "value": "118", "label": "Roboto-Thin", "lang": "en" }, { "value": "119", "label": "RobotoSlab-Regular", "lang": "en" }, { "value": "120", "label": "RobotoSlab-Thin", "lang": "en" }, { "value": "121", "label": "Rufina-Regular", "lang": "en" }, { "value": "122", "label": "Staatliches-Regular", "lang": "en" }, { "value": "123", "label": "TrainOne-Regular", "lang": "en" }, { "value": "124", "label": "Ubuntu-Bold", "lang": "en" }, { "value": "125", "label": "Ubuntu-Light", "lang": "en" }, { "value": "126", "label": "Ubuntu-Regular", "lang": "en" }
  ],
  fontFamilySystem: {
    "宋体, SimSun": "#font_songti",
    "新细明体, PMingLiU": "#font_pmingliu",
    "仿宋,FangSong_GB2312": "#font_fangsong",
    "微软雅黑, Microsoft YaHei": "#font_microsoftyahei",
    "隶书, SimLi": "#font_officialscript",
    "幼圆": "#font_youyuan",
    "华文楷体 ,STKaiti": "#font_sinotype_kaiti",
    "方正舒体": "#font_founder_shuti",
    "华文行楷": "#font_sinotype_kaiti",
    "华文彩云": "#font_sinotype_caiyun",
    "华文宋体": "#font_sinotype_songti",
    "楷体,楷体_GB2312,SimKai": "#font_regularscript",
    "黑体, SimHei": "#font_heiti",
    "Arial": "#font_arial",
    "Tahoma": "#font_tahoma",
    "impact": "#font_impact",
    "Arial Serif": "#font_arial_serif",
    "Times New Roman": "#font_timesnewroman",
    "Georgia": "#font_georgia",
    "Garamond": "#font_garamond",
    "andale mono": "#font_andale_mono",
    "arial black, avant garde": "#font_arial_black",
    "comic sans ms": "#font_comicsansms"
  },
  fontFamilySystemZh: [{
      "value": "宋体, SimSun",
      "label": "宋体",
      "isSystem": true
    },
    {
      "value": "新细明体, PMingLiU",
      "label": "新细明体",
      "isSystem": true
    },
    {
      "value": "仿宋,FangSong_GB2312",
      "label": "仿宋_GB2312",
      "isSystem": true
    },
    {
      "value": "微软雅黑, Microsoft YaHei",
      "label": "微软雅黑",
      "isSystem": true
    },
    {
      "value": "隶书, SimLi",
      "label": "隶书",
      "isSystem": true
    },
    {
      "value": "幼圆",
      "label": "幼圆",
      "isSystem": true
    },
    {
      "value": "华文楷体 ,STKaiti",
      "label": "华文楷体",
      "isSystem": true
    },
    {
      "value": "方正舒体",
      "label": "方正舒体",
      "isSystem": true
    },
    {
      "value": "华文行楷",
      "label": "华文行楷",
      "isSystem": true
    },
    {
      "value": "华文彩云",
      "label": "华文彩云",
      "isSystem": true
    },
    {
      "value": "华文宋体",
      "label": "华文宋体",
      "isSystem": true
    },
    {
      "value": "楷体,楷体_GB2312,SimKai",
      "label": "楷体",
      "isSystem": true
    },
    {
      "value": "黑体, SimHei",
      "label": "黑体",
      "isSystem": true
    },
  ],
  fontFamilySystemEn: [{
      "value": "Arial",
      "label": "Arial",
      "isSystem": true
    },
    {
      "value": "Tahoma",
      "label": "Tahoma",
      "isSystem": true
    },
    {
      "value": "impact",
      "label": "Impact",
      "isSystem": true
    },
    {
      "value": "Arial Serif",
      "label": "Arial Serif",
      "isSystem": true
    },
    {
      "value": "Times New Roman",
      "label": "Times New Roman",
      "isSystem": true
    },
    {
      "value": "Georgia",
      "label": "Georgia",
      "isSystem": true
    },
    {
      "value": "Garamond",
      "label": "Garamond",
      "isSystem": true
    },
    {
      "value": "andale mono",
      "label": "Andale mono",
      "isSystem": true
    },
    {
      "value": "arial black, avant garde",
      "label": "Arial Black",
      "isSystem": true
    },
    {
      "value": "comic sans ms",
      "label": "Comic sans ms",
      "isSystem": true
    }
  ],
  shadowConfig: [{
      value: 'false',
      label: 'view_back_top_index_105',
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'true',
      label: 'view_form_dialog_add_form_213',
      disabled: 'false',
      show: 'true'
    }
  ],
  stickyConfig: [{
      value: 'false',
      label: '关闭',
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'true',
      label: '开启',
      disabled: 'false',
      show: 'true'
    }
  ],
  shadowDirection: [{
    value: 'outset',
    label: 'base_options_config_1722',
  }, {
    value: 'inset',
    label: 'base_options_config_1723',
  }, ],
  historyShow: [{
      value: 'true',
      label: i18n.t('view_form_dialog_add_form_213'),
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'false',
      label: i18n.t('view_back_top_index_105'),
      disabled: 'false',
      show: 'true'
    },
  ],
  insideLink: [{
      value: 'section',
      label: 'base_options_config_1724'
    },
    {
      value: 'product',
      label: 'widgets_basic_classification_edit_482'
    },
    {
      value: 'article',
      label: 'widgets_basic_article_classification_edit_333'
    },
    {
      value: 'case',
      label: 'widgets_basic_article_classification_edit_334'
    },
    {
      value: 'help',
      label: 'widgets_basic_article_classification_edit_335'
    },
    {
      value: 'product_type',
      label: 'base_options_config_1725'
    },
    {
      value: 'article_type',
      label: 'base_options_config_1726'
    },
    {
      value: 'case_type',
      label: 'base_options_config_1727'
    },
    {
      value: 'help_type',
      label: 'base_options_config_1728'
    },
  ],
  linkConfig: [{
      value: 'none',
      label: 'view_left_sidebar_page_setting_full_page_setting_258'
    },
    {
      value: 'inside_link',
      label: 'base_options_config_1729'
    },
    {
      value: 'fun',
      label: 'base_options_config_1730'
    },
    {
      value: 'outside_link',
      label: 'base_options_config_1731'
    }
  ],
  siteSection: [{
      value: 'index',
      label: i18n.t('router_default_70')
    },
    {
      value: 'product_index',
      label: i18n.t('widgets_basic_classification_edit_482')
    },
    {
      value: 'article_index',
      label: i18n.t('base_options_config_1732')
    },
    {
      value: 'contact_us',
      label: i18n.t('router_default_85')
    },
    {
      value: 'about_us',
      label: i18n.t('router_default_82')
    }
  ],
  articleList: [{
      value: 'article_1',
      label: i18n.t('base_options_config_1733')
    },
    {
      value: 'article_2',
      label: i18n.t('base_options_config_1734')
    },
    {
      value: 'article_3',
      label: i18n.t('base_options_config_1735')
    },
    {
      value: 'article_4',
      label: i18n.t('base_options_config_1736')
    }
  ],
  articleTypeList: [{
      value: 'article_type_1',
      label: i18n.t('base_options_config_1737')
    },
    {
      value: 'article_type_2',
      label: i18n.t('base_options_config_1738')
    },
    {
      value: 'article_type_3',
      label: i18n.t('base_options_config_1739')
    },
    {
      value: 'article_type_4',
      label: i18n.t('base_options_config_1740')
    }
  ],
  productList: [{
      value: 'product_1',
      label: i18n.t('base_options_config_1741')
    },
    {
      value: 'product_2',
      label: i18n.t('base_options_config_1742')
    },
    {
      value: 'product_3',
      label: i18n.t('base_options_config_1743')
    },
    {
      value: 'product_4',
      label: i18n.t('base_options_config_1744')
    }
  ],
  productTypeList: [{
      value: 'product_type_1',
      label: i18n.t('base_options_config_1745')
    },
    {
      value: 'product_type_2',
      label: i18n.t('base_options_config_1746')
    },
    {
      value: 'product_type_3',
      label: i18n.t('base_options_config_1747')
    },
    {
      value: 'product_type_4',
      label: i18n.t('base_options_config_1748')
    }
  ],
  newPageOpen: [{
    value: 'true',
    label: 'base_options_config_1749',
    disabled: 'false'
  }],
  newPageNofollow: [{
      value: 'true',
      label: 'base_options_config_1749',
      disabled: 'false'
    },
    {
      value: 'nofol',
      label: 'nofollow',
      disabled: 'false'
    }
  ],
  functionList: [{
      value: 'submit_form',
      label: 'base_options_config_1750'
    },
    // {
    //   value: 'customer_service',
    //   label: '客服'
    // },
    {
      value: 'telephone_advisory',
      label: 'view_dialog_index_167'
    },
    {
      value: 'information_advisory',
      label: 'view_dialog_index_149'
    },
    {
      value: 'file_download',
      label: 'widgets_basic_download_edit_501'
    },
    {
      value: 'jump_section',
      label: 'base_options_config_1751'
    },
    {
      value: 'pop_video',
      label: 'view_dialog_index_168'
    },
    {
      value: 'send_email',
      label: 'view_dialog_index_169'
    }
  ],
  formList: [{
      value: 'form_1',
      label: 'base_options_config_1752'
    },
    {
      value: 'form_2',
      label: 'base_options_config_1753'
    },
    {
      value: 'form_3',
      label: 'base_options_config_1754'
    },
    {
      value: 'form_4',
      label: 'base_options_config_1755'
    }
  ],
  customerServiceList: [{
      value: 'customer_service_1',
      label: 'base_options_config_1756'
    },
    {
      value: 'customer_service_2',
      label: 'base_options_config_1757'
    }
  ],
  downloadPower: [{
      value: 'all',
      label: 'base_options_config_1758',
      disabled: 'true',
      show: 'true'
    },
    {
      value: 'member',
      label: 'base_options_config_1759',
      disabled: 'true',
      show: 'true'
    }
  ],
  jumpType: [{
      value: 'cur_page',
      label: 'base_options_config_1760',
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'other_page',
      label: 'base_options_config_1761',
      disabled: 'false',
      show: 'true'
    }
  ],
  fileTypeAll: [{
      value: 'local_add',
      label: 'base_options_config_1762',
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'common_code',
      label: 'base_options_config_1763',
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'video_address',
      label: 'base_options_config_1764',
      disabled: 'false',
      show: 'true'
    }
  ],
  fileType: [{
      value: 'local_add',
      label: 'base_options_config_1762',
      disabled: 'false',
      show: 'true'
    },
    {
      value: 'video_address',
      label: 'base_options_config_1764',
      disabled: 'false',
      show: 'true'
    }
  ],
  curPageAnchorList: [],
  otherPageAnchorList: [],
  otherPageSection: [],
  imgScaleList: [ // 填充、等比例、平铺、拉伸、原图
    {
      value: 'scale_cover',
      label: 'widgets_basic_article_list_edit_410',
      icon: 'scale_cover img_scale'
    },
    {
      value: 'scale_contain',
      label: 'base_options_config_1765',
      icon: 'scale_contain img_scale'
    },
    {
      value: 'scale_tiling',
      label: 'base_options_config_1766',
      icon: 'scale_tiling img_scale'
    },
    {
      value: 'scale_stretch',
      label: 'base_options_config_1767',
      icon: 'scale_stretch img_scale'
    },
    {
      value: 'scale_original_image',
      label: 'base_options_config_1768',
      icon: 'scale_original_image img_scale'
    }
  ],
  tileEffectList: [ // 平铺效果 默认、缩放平铺、上、中-横向、下、中-纵向、左、右
    {
      value: 'img_default',
      label: 'view_back_top_edit_103',
      icon: 'img_default img'
    },
    {
      value: 'img_zoom_tile',
      label: 'base_options_config_1769',
      icon: 'img_zoom_tile img'
    },
    {
      value: 'img_top',
      label: 'base_options_config_1676',
      icon: 'img_top img'
    },
    {
      value: 'img_mid_horizontal',
      label: 'base_options_config_1770',
      icon: 'img_mid_horizontal img'
    },
    {
      value: 'img_bottom',
      label: 'base_options_config_1677',
      icon: 'img_bottom img'
    },
    {
      value: 'img_mid_vertical',
      label: 'base_options_config_1771',
      icon: 'img_mid_vertical img'
    },
    {
      value: 'img_left',
      label: 'base_options_config_1678',
      icon: 'img_left img'
    },
    {
      value: 'img_right',
      label: 'base_options_config_1679',
      icon: 'img_right img'
    }
  ],
  imgPosList: [{
      value: 'left top',
      label: 'left top'
    },
    {
      value: 'center top',
      label: 'center top'
    },
    {
      value: 'right top',
      label: 'right top'
    },
    {
      value: 'left center',
      label: 'left center'
    },
    {
      value: 'center center',
      label: 'center center'
    },
    {
      value: 'right center',
      label: 'right center'
    },
    {
      value: 'left bottom',
      label: 'left bottom'
    },
    {
      value: 'center bottom',
      label: 'center bottom'
    },
    {
      value: 'right bottom',
      label: 'right bottom'
    }
  ],
  backGroundImageList: {
    scale_cover: {
      background_size: 'cover',
      background_repeat: 'no-repeat',
      background_position: 'center center'
    },
    scale_contain: {
      background_size: 'contain',
      background_repeat: 'no-repeat',
      background_position: 'center center'
    },
    scale_tiling: {
      background_size: 'auto',
      background_repeat: 'repeat',
      background_position: 'center center'
    },
    scale_stretch: {
      background_size: '100% 100%',
      background_repeat: 'no-repeat',
      background_position: 'left center'
    },
    scale_original_image: {
      background_size: 'auto',
      background_repeat: 'no-repeat',
      background_position: 'center center'
    },
    img_default: {
      background_size: 'auto',
      background_repeat: 'repeat',
      background_position: 'center center'
    },
    img_zoom_tile: {
      background_size: '100%',
      background_repeat: 'no-repeat',
      background_position: 'center top'
    },
    img_top: {
      background_size: 'auto',
      background_repeat: 'repeat-x',
      background_position: 'center top'
    },
    img_mid_horizontal: {
      background_size: 'auto',
      background_repeat: 'repeat-x',
      background_position: 'center center'
    },
    img_bottom: {
      background_size: 'auto',
      background_repeat: 'repeat-x',
      background_position: 'center bottom'
    },
    img_mid_vertical: {
      background_size: 'auto',
      background_repeat: 'repeat-y',
      background_position: 'center top'
    },
    img_left: {
      background_size: 'auto',
      background_repeat: 'repeat-y',
      background_position: 'left top'
    },
    img_right: {
      background_size: 'auto',
      background_repeat: 'repeat-y',
      background_position: 'right top'
    }
  },
  dataTypeList: [{
      label: 'base_options_config_1772',
      value: 'date'
    },
    {
      label: 'base_options_config_1773',
      value: 'range'
    }
  ],
  accuracyList: [{
      label: 'base_options_config_1774',
      value: 'date'
    },
    {
      label: 'base_options_config_1775',
      value: 'hour'
    }
  ],
  areaCodeList: [{
      label: 'base_options_config_1776',
      value: 'true'
    },
    {
      label: 'base_options_config_1777',
      value: 'false'
    }
  ],
  enterDigitsList: [{
      label: 'base_options_config_1778',
      value: 'true'
    },
    {
      label: 'base_options_config_1779',
      value: 'false'
    }
  ],
  countyList: [{
      label: 'widgets_basic_article_info_edit_352',
      value: 'true'
    },
    {
      label: 'widgets_basic_article_info_edit_353',
      value: 'false'
    }
  ],
  formItemListNew: {
    input: {
      title: 'Single Line Text', // 标题
      limitType: 'default', // 字数限制 default默认 custom 自定义
      type: 'input', // 该组件使用的组件
      moduleName: 'input', // 该组件名称,必须唯一
      name: '',
      value: '',
      minValue: {
        value: 1,
        min: 1,
        max: 99
      },
      maxValue: {
        value: 100,
        min: 1,
        max: 100
      },
      placeholder: 'Please enter a single line of text', // 输入框占位文本
      show: true, // 是否显示
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验 'idCard' 省份证校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    radio: {
      title: 'Single Button', // 标题
      type: 'radio', // 该组件使用的组件
      moduleName: 'radio',
      name: '',
      value: '',
      selectItem: 'option one\noption two\noption three\n', // 选项
      show: true, // 是否显示
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验 'idCard' 省份证校验
      require: false, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      options: [{
        value: '1',
        label: 'option one'
      },
      {
        value: '2',
        label: 'option two'
      },
      {
        value: '3',
        label: 'option three'
      }
      ],
      width: '100%'
    },
    checkbox: {
      title: 'Multiple Choice Button', // 标题
      type: 'checkbox', // 该组件使用的组件
      moduleName: 'checkbox', // 该组件名称
      name: '',
      value: '',
      selectItem: 'option one\noption two\noption three\n', // 选项
      show: true, // 是否显示
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验 'idCard' 省份证校验
      require: false, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      options: [{
        value: '1',
        label: 'option one'
      },
      {
        value: '2',
        label: 'option two'
      },
      {
        value: '3',
        label: 'option three'
      }
      ],
      width: '100%'
    },
    date: {
      title: 'Date Options', // 标题
      type: 'input', // 该组件使用的组件
      moduleName: 'date', // 该组件名称
      name: '',
      value: '',
      dateType: 'date', // 日期类型 具体日期 date、日期区间 range
      accuracyType: 'date', // 精确程度 精确到日期 date 精确到小时 hour
      show: true, // 是否显示
      placeholder: 'Please select a date and time', // 输入框占位文本
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验 'idCard' 省份证校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    phone: {
      title: 'Phone Number', // 标题
      type: 'input', // 该组件使用的组件
      moduleName: 'phone', // 该组件名称
      name: '',
      value: '',
      areaSelect: 'false', // 区号选择 开启 true 关闭 false
      enterDigitsSelect: 'true', // 输入位数 限定11位 true  限定7-11位 false
      placeholder: 'Please enter the phone number', // 输入框占位文本
      show: true, // 是否显示
      checkType: 'phone', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验 'idCard' 省份证校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    provinces: {
      title: 'Provinces, cities and counties', // 标题
      type: 'provinces', // 该组件使用的组件
      moduleName: 'provinces', // 该组件名称
      name: '',
      value: '',
      countySelect: 'true', // 县区选择 开启 true 关闭 false
      show: true, // 是否显示
      placeholder: 'Please choose', // 输入框占位文本
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验 'idCard' 省份证校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      areaIsOpen: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    select: {
      title: 'Drop Down Options', // 标题
      type: 'select', // 该组件使用的组件
      moduleName: 'select', // 该组件名称
      name: '',
      value: '',
      selectItem: 'option one\noption two\noption three\n', // 选项
      show: true, // 是否显示
      placeholder: 'Please choose', // 输入框占位文本
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      options: [{
        value: '1',
        label: 'option one'
      },
      {
        value: '2',
        label: 'option two'
      },
      {
        value: '3',
        label: 'option three'
      }
      ],
      width: '100%'
    },
    textarea: {
      title: 'Multiline Text', // 标题
      type: 'textarea', // 该组件使用的组件
      moduleName: 'textarea', // 该组件名称
      name: '',
      value: '',
      placeholder: 'Please enter multiple lines of text', // 输入框占位文本
      show: true, // 是否显示
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    upload: {
      title: 'File Upload', // 标题
      type: 'upload', // 该组件使用的组件
      moduleName: 'upload', // 该组件名称
      name: '',
      value: '',
      placeholder: 'Please upload file', // 输入框占位文本
      show: true, // 是否显示
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认,
      display: false,
      width: '100%'
    },
    text: {
      title: 'Text Description', // 标题
      type: 'text', // 该组件使用的组件
      moduleName: 'text', // 该组件名称
      name: '',
      value: '',
      mainTitle: '', // 主标题
      subtitle: '', // 副标题
      placeholder: 'Description', // 输入框占位文本
      show: true, // 是否显示
      checkType: '', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    IDCard: {
      title: 'Authentication', // 标题
      type: 'input', // 该组件使用的组件
      moduleName: 'IDCard', // 该组件名称
      name: '',
      value: '',
      placeholder: 'Please enter your ID number', // 输入框占位文本
      show: true, // 是否显示
      checkType: 'IDCard', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    },
    email: {
      title: 'Email Verification', // 标题
      type: 'input', // 该组件使用的组件
      moduleName: 'email', // 该组件名称
      name: '',
      value: '',
      placeholder: 'Please input your email', // 输入框占位文本
      show: true, // 是否显示
      checkType: 'email', // 校验类型 text 文本校验 telephone 手机校验 email 邮箱校验 '' 不进行校验
      require: true, // 是否必填
      disabled: false, // 是否禁用
      isSystem: false, // 系统默认
      display: false,
      width: '100%'
    }
  },
  formItemOneRow: [{
      name: 'input',
      title: 'base_options_config_1780',
      icon: 'icon_singleLine'
    },
    {
      name: 'radio',
      title: 'base_options_config_1781',
      icon: 'icon_radio'
    },
    {
      name: 'checkbox',
      title: 'base_options_config_1782',
      icon: 'icon_multipleChoice'
    }
  ],
  formItemTwoRow: [{
      name: 'date',
      title: 'base_options_config_1783',
      icon: 'icon_date'
    },
    {
      name: 'phone',
      title: 'base_options_config_1784',
      icon: 'icon_phone'
    },
    {
      name: 'provinces',
      title: 'base_options_config_1785',
      icon: 'icon_address'
    }
  ],
  moreList: [{
      children: [{
          name: 'select',
          title: 'base_options_config_1786',
          icon: 'icon_dropDown'
        },
        {
          name: 'textarea',
          title: 'base_options_config_1787',
          icon: 'icon_multiLine'
        },
        {
          name: 'IDCard',
          title: 'view_login_index_39',
          icon: 'icon_identity'
        }
      ]
    },
    {
      children: [{
        name: 'email',
        title: 'base_options_config_1788',
        icon: 'icon_mail'
      }]
    }
  ],
  baseColor: [{
      name: i18n.t('base_options_config_1789'),
      key: 'default_1',
      color: 'rgba(239,65,54,1)',
    },
    {
      name: i18n.t('base_options_config_1790'),
      key: 'default_2',
      color: 'rgba(252,104,50,1)',
    },
    {
      name: i18n.t('base_options_config_1791'),
      key: 'default_3',
      color: 'rgba(255,188,0,1)',
    },
    {
      name: i18n.t('base_options_config_1792'),
      key: 'default_4',
      color: 'rgba(82,181,72,1)',
    },
    {
      name: i18n.t('base_options_config_1793'),
      key: 'default_5',
      color: 'rgba(10,187,185,1)',
    },
    {
      name: i18n.t('base_options_config_1794'),
      key: 'default_6',
      color: 'rgba(43,160,232,1)',
    },
    {
      name: i18n.t('base_options_config_1795'),
      key: 'default_7',
      color: 'rgba(30,80,174,1)',
    },
    {
      name: i18n.t('base_options_config_1796'),
      key: 'default_8',
      color: 'rgba(43,43,43,1)',
    },
    {
      name: i18n.t('base_options_config_1797'),
      key: 'default_9',
      color: 'rgba(179,141,84,1)',
    }
  ],
  fixed_height: [{
      label: 'base_options_config_1798',
      value: 'all'
    },
    {
      label: 'base_options_config_1799',
      value: 'system'
    }
  ],
  group_type_list: [
    {
      "value": "30",
      "label": i18n.t('base_options_config_1800')
    },
    {
      "value": "31",
      "label": i18n.t('base_options_config_1801')
    },
    {
      "value": "18",
      "label": i18n.t('base_module_config_1663')
    },
    {
      "value": "32",
      "label": i18n.t('base_options_config_1802')
    },
    {
      "value": "12",
      "label": i18n.t('base_options_config_1803')
    },
    {
      "value": "13",
      "label": i18n.t('router_default_83')
    },
    {
      "value": "15",
      "label": i18n.t('base_options_config_1804')
    },
    {
      "value": "33",
      "label": i18n.t('base_options_config_1805')
    },
    {
      "value": "14",
      "label": i18n.t('widgets_basic_development_history_components_my_historys_index_492')
    },
    {
      "value": "16",
      "label": "FAQ"
    },
    // {
    //   "value": "34",
    //   "label": "底部栏"
    // },
    {
      "value": "19",
      "label": i18n.t('base_options_config_1806')
    },
    {
      "value": "35",
      "label": i18n.t('base_options_config_1807')
    }
  ],
  add_img_option: [{
      value: 'custom',
      label: 'widgets_basic_article_list_edit_400'
    },
    {
      value: 'systom',
      label: 'base_options_config_1808'
    }
  ],
  add_atlas_option: [{
      value: 'custom',
      label: 'widgets_basic_article_list_edit_400'
    },
    {
      value: 'systom',
      label: 'widgets_basic_article_list_edit_401'
    }
  ],
  add_sys_options: [{
      value: 'system',
      label: 'widgets_basic_article_list_edit_402'
    },
    {
      value: 'custom',
      label: 'view_back_top_edit_102'
    }
  ],
  add_pro_option: [{
      value: 'label',
      label: 'base_options_config_1809'
    },
    {
      value: 'custom',
      label: 'widgets_basic_article_list_edit_400'
    },
    {
      value: 'systom',
      label: 'widgets_basic_article_list_edit_401'
    }
  ],
  isSHow: [{
      value: 'true',
      label: 'view_form_dialog_add_form_213',
    },
    {
      value: 'false',
      label: 'view_back_top_index_105',

    }
  ],
  backgroundSize_option: [{
      value: 'default',
      label: 'view_back_top_edit_103',
    },
    {
      value: 'cover',
      label: 'widgets_basic_article_list_edit_410',
    },
    {
      value: 'auto',
      label: 'widgets_basic_article_list_edit_411',
    }
  ],
  banner_set_option: [{
      value: 'default',
      label: 'view_back_top_edit_103',
    },
    {
      value: 'custom',
      label: 'base_options_config_1810',
    },
    {
      value: 'autoplay_false',
      label: 'base_options_config_1811',
    }
  ],

  default_custom: [{
      value: 'default',
      label: 'view_back_top_edit_103',
    },
    {
      value: 'custom',
      label: 'view_back_top_edit_102',
    }
  ],
  col_num: [{
      value: 1,
      label: '1',
    },
    {
      value: 2,
      label: '2',
    },
    {
      value: 3,
      label: '3',
    },
    {
      value: 4,
      label: '4',
    },
    {
      value: 5,
      label: '5',
    },
    {
      value: 6,
      label: '6',
    },
  ],
  col_num_8: [{
      value: 1,
      label: '1',
    },
    {
      value: 2,
      label: '2',
    },
    {
      value: 3,
      label: '3',
    },
    {
      value: 4,
      label: '4',
    },
    {
      value: 5,
      label: '5',
    },
    {
      value: 6,
      label: '6',
    },
    {
      value: 7,
      label: '7',
    },
    {
      value: 8,
      label: '8',
    },
  ],
  col_num_4: [{
      value: 1,
      label: '1',
    },
    {
      value: 2,
      label: '2',
    },
    {
      value: 3,
      label: '3',
    },
    {
      value: 4,
      label: '4',
    },
  ],
  videoPlay: [{
      value: true,
      label: 'base_options_config_1812',
    },
    {
      value: false,
      label: 'base_options_config_1813',
    },
  ],
  jump_way: [{
      value: '_blank',
      label: 'view_left_sidebar_setting_293',
    },
    {
      value: '_self',
      label: 'view_left_sidebar_setting_292',
    }
  ],
  moduleAlign: [{
      title: 'base_kindeditor_all_1503',
      icon_class: 'f-icon-aligentLeft',
      value: 'left'
    },
    {
      title: 'base_kindeditor_all_1504',
      icon_class: 'f-icon-aligentRight',
      value: 'right'
    },
    {
      title: 'base_options_config_1683',
      icon_class: 'f-icon-aligentCenter',
      value: 'center'
    }
  ],
  tipsObj: {
    section: i18n.t('base_options_config_1814'),
    product: i18n.t('view_dialog_index_118'),
    article: i18n.t('view_dialog_index_120'),
    case: i18n.t('view_dialog_index_122'),
    help: i18n.t('view_dialog_index_124'),
    product_type: i18n.t('view_dialog_index_126'),
    article_type: i18n.t('view_dialog_index_128'),
    case_type: i18n.t('view_dialog_index_130'),
    help_type: i18n.t('view_dialog_index_132'),
    submit_form: i18n.t('view_dialog_index_137'),
    customer_service: i18n.t('base_options_config_1815'),
    telephone_advisory: i18n.t('view_dialog_index_144'),
    information_advisory: i18n.t('view_dialog_index_146'),
    file_download: i18n.t('base_options_config_1816'),
    jump_section: i18n.t('base_options_config_1817'),
    local_add: i18n.t('base_options_config_1818'),
    common_code: i18n.t('base_options_config_1819'),
    video_address: i18n.t('view_dialog_index_166'),
    outside_link: i18n.t('base_options_config_1820'),
    send_email: i18n.t('base_options_config_1821'),
  },
  search_options: [{
      value: 'true',
      label: 'widgets_basic_article_info_edit_352',
    },
    {
      value: 'false',
      label: 'widgets_basic_article_info_edit_353',
    }
  ],
  direction: [{
      label: 'base_options_config_1822',
      value: 'left',
    },
    {
      label: 'base_options_config_1823',
      value: 'right',
    },
    {
      label: 'base_options_config_1824',
      value: 'up',
    },
    {
      label: 'base_options_config_1825',
      value: 'down',
    }
  ],
  roll_speed: [{
      label: 'base_options_config_1826',
      value: 7.5,
      id: 'slow'
    },
    {
      label: 'base_options_config_1827',
      value: 5,
      id: 'normal'
    },
    {
      label: 'base_options_config_1828',
      value: 2.5,
      id: 'fast'
    }
  ],
  yy_roll_speed: [{
      label: 'base_options_config_1826',
      value: 'slow'
    },
    {
      label: 'base_options_config_1827',
      value: 'normal'
    },
    {
      label: 'base_options_config_1828',
      value: 'fast'
    }
  ],
  roll_way: [{
    label: 'base_options_config_1829',
    value: 'in'
  }, {
    label: 'base_options_config_1830',
    value: 'out'
  }],
  roll_loop: [{
    label: 'base_options_config_1812',
    value: true
  }, {
    label: 'base_options_config_1813',
    value: false
  }],
  roll_wait: [{
    label: 'base_options_config_1831',
    value: 1
  }, {
    label: 'base_options_config_1832',
    value: 3
  }, {
    label: 'base_options_config_1833',
    value: 5
  }, {
    label: 'base_options_config_1834',
    value: 7
  }],
  notice_img: [{
    value: 'custom',
    label: 'view_form_dialog_add_form_213',
  }, {
    value: 'default',
    label: 'view_back_top_index_105',
  }],
  display_position: [{
      value: 'header',
      label: 'view_left_sidebar_page_setting_page_setting_274',
    },
    {
      value: 'footer',
      label: 'view_left_sidebar_page_setting_page_setting_275',
    }
  ],
  nav_position: [{
      value: 'left',
      label: 'base_options_config_1684',
    },
    {
      value: 'right',
      label: 'base_options_config_1685',
    }
  ],
  content_style_list: [{
      value: '1',
      label: 'base_options_config_1835',
    },
    {
      value: '2',
      label: 'base_options_config_1836',
    },
    {
      value: '3',
      label: 'base_options_config_1837',
    }
  ],
  col_order: [{
      value: 'default',
      label: 'view_back_top_edit_103',
    },
    {
      value: 'custom',
      label: 'view_back_top_edit_102',
    }
  ],
  fullPageStyleType: [{
    value: '0',
    label: 'type0'
  }, {
    value: '1',
    label: 'type1'
  }, {
    value: '2',
    label: 'type2'
  }, {
    value: 'hidden',
    label: 'view_back_top_index_105'
  }, ],
  topNavType: [{
      value: 'true',
      label: 'base_options_config_1776',
    },
    {
      value: 'false',
      label: 'base_options_config_1777',
    },
  ],
  fullPageTopNavType: [{
    value: 'xuanfu',
    label: 'base_options_config_1838',
  }, {
    value: 'zhanwei',
    label: 'base_options_config_1839',
  }],
  footerType: [{
    value: 'type0',
    label: 'base_options_config_1840'
  }, {
    value: 'type1',
    label: 'base_options_config_1841'
  }, {
    value: 'hidden',
    label: 'view_back_top_index_105'
  }],
  rowFooterType: [{
    value: 'typeRow1',
    label: 'base_options_config_1841'
  }, {
    value: 'hidden',
    label: 'view_back_top_index_105'
  }],
  scrollType: [{
    value: 'normal',
    label: 'base_options_config_1842'
  }, {
    value: 'col',
    label: 'base_options_config_1843'
  }, {
    value: 'row',
    label: 'base_options_config_1844'
  }],
  jobField: [{
    value: 'address',
    label: 'base_options_config_1845'
  }, {
    value: 'jobType',
    label: 'base_options_config_1846'
  }, {
    value: 'salary',
    label: 'base_options_config_1847'
  }, {
    value: 'require',
    label: 'base_options_config_1848'
  }, {
    value: 'endTime',
    label: 'base_options_config_1849'
  }],
  tagLayout: [{
    value: 'left',
    label: 'base_options_config_1684'
  }, {
    value: 'center',
    label: 'widgets_basic_floating_frame_edit_537'
  }, {
    value: 'right',
    label: 'base_options_config_1685'
  }, {
    value: 'stretch',
    label: 'base_options_config_1850'
    }],
  tagPosition: [{
    value: 'top',
    label: 'base_options_config_1676'
  }, {
    value: 'bottom',
    label: 'base_options_config_1677'
    }],
  formLayout: [{
    value: 'oneColumn',
    label: 'base_options_config_3028'
  }, {
    value: 'twoColumns',
    label: 'base_options_config_3029'
    }],
  position_options: [{
    value: 'left',
    label: 'base_options_config_1851'
  }, {
    value: 'right',
    label: 'base_options_config_1852'
  }, {
    value: 'top',
    label: 'base_options_config_1853'
  },{
    value: 'bottom',
    label: 'base_options_config_1854'
  },],
  triggerType: [{
    value: 'hover',
    label: 'base_options_config_1855'
  }, {
    value: 'click',
    label: 'base_options_config_1856'
  }],
  tabPanelHeight: [{
    value: 'group',
    label: 'base_options_config_1857'
  }, {
    value: 'single',
    label: 'base_options_config_1858'
  }],
  inlineSplitLine: [{
    value: 'vertical',
    label: '|'
  }, {
    value: 'slash',
    label: '/'
  }],
  underline: [{
    value: 'long',
    label: 'base_options_config_1859'
  }, {
    value: 'short',
    label: 'base_options_config_1860'
  }, {
    value: 'hidden',
    label: 'view_back_top_index_105'
  }],
  showOrHidden: [{
      value: 'show',
      label: 'view_form_dialog_add_form_213',
    },
    {
      value: 'hidden',
      label: 'view_back_top_index_105',
    }
  ],
  languageContentData: {
    "zh-cn": [i18n.t("base_options_config_1861"), "中文"],
    "ar-il": [i18n.t("base_options_config_1863"), "عربى"],
    "de-de": [i18n.t("base_options_config_1864"), "Deutsche"],
    "en-us": [i18n.t("base_options_config_1865"), "English"],
    "es-es": [i18n.t("base_options_config_1866"), "Español"],
    "fa-ir": [i18n.t("base_options_config_1867"), "فارسی"],
    "fr-fr": [i18n.t("base_options_config_1868"), "français"],
    "hi-in": [i18n.t("base_options_config_1869"), "हिंदी"],
    "in-id": [i18n.t("base_options_config_1870"), "bahasa Indonesia"],
    "it-it": [i18n.t("base_options_config_1871"), "italiano"],
    "ja-jp": [i18n.t("base_options_config_1872"), "日語"],
    "kk-kz": [i18n.t("base_options_config_1874"), "Қазақ"],
    "ko-kr": [i18n.t("base_options_config_1875"), "한국어"],
    "ky-kg": [i18n.t("base_options_config_1876"), "Кыргызча"],
    "ne-np": [i18n.t("base_options_config_1877"), "नेपाली"],
    "nl-nl": [i18n.t("base_options_config_1878"), "Nederlands"],
    "ps-ar": [i18n.t("base_options_config_1879"), "پښتو"],
    "pt-br": [i18n.t("base_options_config_1880"), "Português"],
    "ro-ro": [i18n.t("base_options_config_1881"), "Română"],
    "ru-ru": [i18n.t("base_options_config_1882"), "русский"],
    "th-th": [i18n.t("base_options_config_1883"), "ไทย"],
    "tr-tr": [i18n.t("base_options_config_1884"), "Türk"],
    "uz-uz": [i18n.t("base_options_config_1885"), "O'zbek"],
    "zh-tw": [i18n.t("base_options_config_1886"), "繁體"],
    "vi-vn": [i18n.t("base_options_config_1888"), "Tiếng Việt"],
    "el-gr": [i18n.t("base_options_config_1889"), "Ελληνικά"],
    "ms-my": [i18n.t("base_options_config_1890"), "Bahasa Melayu"],
    "zh-ch": [i18n.t("base_options_config_1891"), "中文简体"],
    "bn-bn": [i18n.t("base_options_config_1893"), "বাংলা"],
    "my-my": [i18n.t("base_options_config_1894"), "ဗမာ"],
    "fi-fi": [i18n.t("base_options_config_1895"), "Suomalainen"],
    "nb-no": [i18n.t("base_options_config_1896"), "norsk"],
    "pl-pl": [i18n.t("base_options_config_1897"), "Polskie"],
    "et-ee": [i18n.t("base_options_config_1898"), "Eestlane"],
    "bg-bg": [i18n.t("base_options_config_1899"), "български"],
    "da-dk": [i18n.t("base_options_config_1900"), "dansk"],
    "lv-lv": [i18n.t("base_options_config_1901"), "Latvietis"],
    "lt-lt": [i18n.t("base_options_config_1902"), "Lietuvių"],
    "sv-se": [i18n.t("base_options_config_1903"), "svenska"],
    "sl-si": [i18n.t("base_options_config_1904"), "Slovenščina"],
    "sk-sk": [i18n.t("base_options_config_1905"), "Slovenský"],
    "hu-hu": [i18n.t("base_options_config_1906"), "Magyar"],
    "he-il": [i18n.t("base_options_config_1907"), "עִברִית"],
    "mr-in": [i18n.t("base_options_config_1908"), "मराठी"],
    "cs-cz": [i18n.t("base_options_config_1909"), "čeština"],
    "sr-sp": [i18n.t("base_options_config_1910"), "Српски"],
    "hr-hr": [i18n.t("base_options_config_1911"), "Hrvatski"],
    "uk-ua": [i18n.t("base_options_config_1912"), "Українська"],
    "sq-al": [i18n.t("base_options_config_1913"), "Shqiptare"],
    "sw-ke": [i18n.t("base_options_config_1914"), "Kiswahili"]
  },
  move_option: [{
      value: false,
      label: 'base_options_config_1813',
    },
    {
      value: true,
      label: 'base_options_config_1812',
    }
  ],
  navChildTextAlign: [{
    value: 'center',
    label: 'base_options_config_1683',
  }, {
    value: 'left',
    label: 'base_kindeditor_all_1503',
  }, {
    value: 'right',
    label: 'base_kindeditor_all_1504',
  }],
  navTextAlign: [{
    value: 'center',
    label: 'base_options_config_1683',
  }, {
    value: 'left',
    label: 'base_kindeditor_all_1503',
  }, {
    value: 'right',
    label: 'base_kindeditor_all_1504',
  }],
  adaptWidthIsOpen: [{
    label: 'widgets_basic_article_info_edit_352',
    value: 'true'
  }, {
    label: 'widgets_basic_article_info_edit_353',
    value: 'false'
  }],
  adaptWidth: [{
    label: '960',
    value: 960
  }, {
    label: '1200',
    value: 1200
  }, {
    label: 'view_back_top_edit_102',
    value: 'custom'
  }],
  rowContentWidth: [{
    label: 'base_options_config_1915',
    value: 'normal',
    sampleImgVisible: false,
    sampleImgUrl: '/static/image/row/normal_width.gif',
    sampleBackgroundImgUrl: '/static/image/row/normal_width.png'
  }, {
    label: 'base_options_config_1916',
    value: 'adapt',
    sampleImgVisible: false,
    sampleImgUrl: '/static/image/row/adapt_width.gif',
    sampleBackgroundImgUrl: '/static/image/row/adapt_width.png'
  }],
  adaptBackground: [{
    label: 'widgets_basic_article_info_edit_352',
    value: 'true'
  }, {
    label: 'widgets_basic_article_info_edit_353',
    value: 'false'
  }],
  textAlignOption: [{
    value: 'left',
    label: 'base_options_config_1684',
  }, {
    value: 'center',
    label: 'widgets_basic_floating_frame_edit_537',
  }, {
    value: 'right',
    label: 'base_options_config_1685',
  }],
  textAlignOption1: [{
    value: 'left',
    label: 'base_kindeditor_all_1503',
  }, {
    value: 'center',
    label: 'widgets_basic_floating_frame_edit_537',
  }, {
    value: 'right',
    label: 'base_kindeditor_all_1504',
  }],
  xuanfuPositionType: [{
      value: 'index',
      label: 'router_default_70',
    },
    {
      value: 'station',
      label: 'base_options_config_1917',
    },
  ],
  showList: [
    {
      label: 'view_form_dialog_add_form_213',
      value: true
    },
    {
      label: 'view_back_top_index_105',
      value: false
    }
  ],
}



// WEBPACK FOOTER //
// ./src/base/options_config.js